module.exports = __webpack_public_path__ + "media/post-listing-block-4-image@2x.82a1f6ba.jpg";